import * as React from 'react'
import type { SVGProps } from 'react'

interface SvgHomeSimpleProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}
const ACTIVE_COLOR = '#002A73'
const INACTIVE_STROKE_COLOR = '#CECECE'

const ICON_SIZE = 28
const VIEW_BOX = '0 0 28 28'

const housePathD =
  'M4.375 23.6247H23.625V13.1247C23.6251 13.0098 23.6025 12.8959 23.5586 12.7897C23.5147 12.6835 23.4503 12.587 23.3691 12.5056L14.6191 3.75565C14.5378 3.67429 14.4413 3.60976 14.3351 3.56572C14.2288 3.52169 14.115 3.49902 14 3.49902C13.885 3.49902 13.7712 3.52169 13.6649 3.56572C13.5587 3.60976 13.4622 3.67429 13.3809 3.75565L4.63094 12.5056C4.54971 12.587 4.4853 12.6835 4.44138 12.7897C4.39747 12.8959 4.37491 13.0098 4.375 13.1247V23.6247Z'

const SvgHomeSimple = ({
  isActive = false,
  stroke,
  width,
  height,
  ...props
}: SvgHomeSimpleProps) => {
  const currentStrokeColor = isActive
    ? ACTIVE_COLOR
    : stroke || INACTIVE_STROKE_COLOR

  return (
    <svg
      {...props}
      width={width ?? ICON_SIZE}
      height={height ?? ICON_SIZE}
      viewBox={VIEW_BOX}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {isActive && <path opacity='0.2' d={housePathD} fill={ACTIVE_COLOR} />}

      <path
        d={housePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SvgHomeSimple
